import React from 'react';
import { motion } from 'framer-motion';
interface CTAButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  href?: string;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  href = '#oferta'
}: CTAButtonProps) {
  const baseClasses = 'inline-block w-full sm:w-auto text-center py-5 px-8 md:px-12 text-xl md:text-2xl font-bold rounded-full bg-brand-gold text-brand-brown hover:bg-brand-goldDark transition-colors shadow-lg hover:shadow-xl transform hover:-translate-y-1 duration-300';
  if (href) {
    return <a href={href} className={`${baseClasses} ${className}`} data-id="element-173">
        {children}
      </a>;
  }
  return <button onClick={onClick} className={`${baseClasses} ${className}`} data-id="element-174">
      {children}
    </button>;
}